import { Outlet } from "react-router-dom";

interface CashiersRProps {}

const GamesControl: React.FC<CashiersRProps> = () => {
  return <Outlet />;
};

export default GamesControl;
